var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"abstract-3",attrs:{"src":require('@/assets/abstract3.png'),"height":"100%","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }